export default class ModelsState {
    list: string[] = [];
    selected: string = null;
}
